import script from "./PublicHomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicHomeView.vue?vue&type=script&setup=true&lang=js"

import "./PublicHomeView.vue?vue&type=style&index=0&id=79d7baf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79d7baf0"]])

export default __exports__